import { IAppState } from 'src/store/types';

export const getListOfTypeDisplayedSpinner = (state: IAppState) => state.typeDisplayedSpinner.listOfTypes;
export const getSelectedView = (state: IAppState) => state.typeDisplayedSpinner.selectedView;
